import { useCallback, useEffect, useState } from "react";
import { Alert, Button, Card, Col, Row } from "react-bootstrap";
import * as icons from "react-bootstrap-icons";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { PlayerGetManagers } from "../../redux/auth-reducer/auth-service";
import {
  DISCOVER_MANAGERS_COUNT,
  MANAGER_STATUS,
  sentMessage,
  sportsLabel,
} from "../../utils/helper/managers";
import { ManagerIdentity } from "../../CommonComponent/Managers/ManagerIdentity";
import { SubscribeConfirmModal } from "../../CommonComponent/Managers/SubscribeConfirmModal";

/**
 * "Discover Managers" on the Player dashboard (#133): the five Available managers with the most
 * subscribed players, ties alphabetical - the server's order for the Available filter
 * (usp_GetAllPlayerManager). Subscribe opens the same confirmation dialog as the Managers page,
 * so nothing is sent from here without it; View All is the Managers page.
 */
export const DiscoverManagers = () => {
  const [managers, setManagers] = useState(null);
  const [confirmManager, setConfirmManager] = useState(null);
  const [notice, setNotice] = useState("");

  const load = useCallback(async () => {
    const res = await PlayerGetManagers({
      Status: MANAGER_STATUS.AVAILABLE,
      PageNumber: 1,
      PageSize: DISCOVER_MANAGERS_COUNT,
    });
    // No reply keeps what is on screen; apiClient has already said so.
    if (res?.data) setManagers(res.data.data?.dataList || []);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const handleSent = (result) => {
    setConfirmManager(null);
    load();
    if (result.sentCount > 0) setNotice(sentMessage(result, "Pending tab"));
    else toast.error(result.message);
  };

  return (
    <Card className="mt-4 discover-managers">
      {notice && (
        <Alert variant="success" dismissible onClose={() => setNotice("")} className="managers-notice">
          <icons.CheckCircleFill className="me-2" />
          {notice}
        </Alert>
      )}
      <Row>
        <Col xs="8">
          <h2>Discover Managers</h2>
        </Col>
        <Col xs="4" className="text-right">
          <Link to="/Player/Managers">View All</Link>
        </Col>
      </Row>

      {managers && managers.length === 0 && (
        <div className="discover-empty">No new managers to discover</div>
      )}

      {managers?.map((manager) => (
        <div className="discover-row" key={manager.managerId}>
          <ManagerIdentity manager={manager} compact />
          <span className="discover-players">
            {manager.playerCount} {manager.playerCount === 1 ? "player" : "players"}
          </span>
          {/* #212: left out when an API from before the count sends none, rather than "0 sports". */}
          {typeof manager.sportCount === "number" && (
            <span className="discover-sports">{sportsLabel(manager.sportCount)}</span>
          )}
          <Button size="sm" onClick={() => setConfirmManager(manager)}>
            Subscribe
          </Button>
        </div>
      ))}

      <SubscribeConfirmModal
        show={Boolean(confirmManager)}
        managers={confirmManager ? [confirmManager] : []}
        onCancel={() => setConfirmManager(null)}
        onSent={handleSent}
      />
    </Card>
  );
};
